import { SELECT_COMPANY, SELECT_TEAM } from '../types'

export const selectCompanyIdAction = id => dispatch => dispatch({ type: SELECT_COMPANY, payload: id })

export const selectTeamIdAction = id => (dispatch, getState) => {
  id && id !== 'all' && dispatch({ type: SELECT_COMPANY, payload: getState().firestore.teams.find(t => t.id === id).companyRef.id })
  return dispatch({ type: SELECT_TEAM, payload: id })
}
